import { useQueryClient } from '@tanstack/react-query';
import { BroadcastTopics } from 'services/wsService';
import { useSocketOn } from 'infrastructure/hooks/websockets/use-socket-on';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';

import { getRunbookViewedKey } from './use-get-runbook-viewed';
import { runbookLogsLoadKey } from './use-runbook-logs';

interface ISocketData {
  clinicGuid: string;
}

interface Props {
  isShowDataNotification?: boolean;
}

export const useRealTimeUpdateRunbookViewed = ({
  isShowDataNotification,
}: Props) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const updateRunbookViewed = (socketData: ISocketData) => {
    const { clinicGuid } = socketData;

    const viewedQueryKey = getRunbookViewedKey(clinicGuid);
    const logsQueryKey = [runbookLogsLoadKey];

    queryClient.refetchQueries({ queryKey: viewedQueryKey });
    queryClient.refetchQueries({ queryKey: logsQueryKey });

    if (isShowDataNotification) {
      notificationController.info({
        message: t('runbook.updateInfoMessage'),
        closable: true,
      });
    }
  };

  useSocketOn(BroadcastTopics.ClinicInstructionsChange, updateRunbookViewed);

  return { updateRunbookViewed };
};
